import { receive_related_stories } from "../../reducers/VideoDetail/reducer";
import { fetchMediaRelatedStories } from "../../fetch/graphql/requests/mlDrivenItems/library";
import log from "../../utils/logger/library";

export const fetch_ml_driven_media_related_stories = (sourceId) => {
    return async (dispatch) => {
        try {
            const response = await fetchMediaRelatedStories(sourceId);
            const relatedStories = response?.data?.relatedItems?.nodes ?? [];

            dispatch(receive_related_stories(relatedStories));
        } catch (error) {
            log.error(
                `(fetch_ml_driven_media_related_stories) request failed for ${sourceId}`,
                error
            );
            throw error;
        }
    };
};
